import {
  RESTART_PANELS_HISTORY,
  RESET_PANELS_STATE,
  SET_ACTIVE_NON_ERROR_PANEL,
  SET_ACTIVE_PANEL,
  SET_PREVIOUS_PANEL,
} from "../actions/types";
import { panels } from "../../variables";

const defaultState = {
  activePanel: undefined,
  panelsHistory: [],
};
const updatePanels = (state, action) => {
  if (!state) {
    return defaultState;
  }
  switch (action.type) {
    case RESTART_PANELS_HISTORY:
      return resetHistory(state);
    case SET_ACTIVE_PANEL:
      return updateActivePanel(state, action.payload);
    case SET_PREVIOUS_PANEL:
      return updatePreviousPanel(state);
    case SET_ACTIVE_NON_ERROR_PANEL:
      return updateNonErrorPanel(state);
    case RESET_PANELS_STATE:
      return {
        ...defaultState,
      };
    default:
      return {
        ...state.panels,
      };
  }
};

const resetHistory = (state) => {
  return {
    ...state.panels,
    activePanel: panels.equeues,
    panelsHistory: [panels.equeues],
  };
};

const updatePreviousPanel = (state) => {
  const newHistory = state.panels.panelsHistory.slice(0, -1);
  let newViewPanel = newHistory.slice(-1)[0];

  return {
    ...state.panels,
    activePanel: newViewPanel,
    panelsHistory: newHistory,
  };
};

const updateActivePanel = (state, newPanel) => {
  const panelsHistory = [...state.panels.panelsHistory];
  panelsHistory.push(newPanel);
  window.history.pushState(null, "", window.location.href);
  return {
    ...state.panels,
    activePanel: newPanel,
    panelsHistory: panelsHistory,
  };
};

const updateNonErrorPanel = (state) => {
  const panelsHistory = [...state.panels.panelsHistory];
  panelsHistory.pop();
  return {
    ...state.panels,
    activePanel: panelsHistory.slice(-1)[0],
    panelsHistory: panelsHistory,
  };
};

export default updatePanels;
